import {Modal} from '@/components/atoms'
import {UploadFile} from '@/components/molecules'
import {uploadFileDescriptionForCSV} from '@/utils/commonTemplate'
import {Constants} from '@/utils/constants/commonConstants'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {useRef, useState} from 'react'

const FileUploadWithModal = ({
  uploadFor = null,
  openUpload,
  setOpenUpload,
  formData,
  setFormData,
  title = 'Upload Targets',
  showTertiaryButton = false,
  label = Constants.UploadStoresFile,
  required = true,
  toastMessage = 'Product list has been uploaded',
  showTertiaryDownloadButton = false,
  tertiaryButtonText,
  acceptedExtensions = Constants.CSV,
  onClickTertiaryButton = () => {},
  ...props
}) => {
  const [uploadError, setUploadError] = useState(false)
  const childRef = useRef()

  const isFileError = uploadError
  const fileIsEmpty = !formData?.targetMediaFile?.length

  const resetUploadState = () => {
    childRef.current?.clearError?.()
    setUploadError(false)
    props.onUploadSuccess?.()
  }

  const handleDelete = () => {
    setFormData(prev => ({
      ...prev,
      targetMediaFile: [],
    }))
  }

  const closeModal = () => {
    resetUploadState()
    handleDelete()
    setOpenUpload(false)
  }

  const handleUpload = file => {
    setFormData(prev => ({
      ...prev,
      targetMediaFile: [file?.name],
    }))
  }

  const handleButtonClick = () => {
    if (title === Constants.bulkUploadPromotions) {
      childRef.current?.bulkPromotionFileUpload()
    } else if (title === `Upload Suggested SKU's`) {
      childRef.current?.suggestedSKUFileUpload()
    } else {
      childRef.current?.fileUpload()
    }
  }
  return (
    <Modal
      isDark={true}
      showModal={openUpload}
      onCloseModal={closeModal}
      onClickSecondaryButton={closeModal}
      onClickPrimaryButton={handleButtonClick}
      primaryButtonText="Done"
      primaryButtonDisabled={isFileError || fileIsEmpty}
      type={MODAL_TYPE.SMALL}
      className="upload-target-modal"
      showSecondaryButton
      showTertiaryButton={showTertiaryDownloadButton || (isFileError && showTertiaryButton)}
      onClickTertiaryButton={onClickTertiaryButton}
      tertiaryButtonText={tertiaryButtonText}
      tertiaryButtonIconLeading={'file_download'}
      title={title}
      data-testId="upload-target-modal"
      content={
        <UploadFile
          uploadFor={uploadFor}
          acceptedExtensions={acceptedExtensions}
          description={uploadFileDescriptionForCSV({acceptedExtensions})}
          label={label}
          variant={Constants.Edit}
          required={required}
          files={formData?.targetMediaFile?.length ? [formData.targetMediaFile] : []}
          onUpload={handleUpload}
          onUploadDelete={handleDelete}
          onUploadError={hasError => setUploadError(hasError)}
          type={Constants.Single}
          showDownloadTemplate={false}
          showHandleViewTable={false}
          className={formData?.targetMediaFile?.length && isFileError ? 'disabled' : ''}
          containerClassName={formData?.targetMediaFile?.length ? 'disabled' : ''}
          dataTestId="upload-file"
          onCloseModal={closeModal}
          getFileUrl={url => setFormData(prev => ({...prev, storeList: url}))}
          ref={childRef}
          toastMessage={toastMessage}
          {...props}
        />
      }
    />
  )
}

export default FileUploadWithModal
